export default [
  {
    id: 1,
    textDropDownEn: "--Choose--",
  },

  {
    id: 2,
    textDropDownEn: "Residential",
  },

  {
    id: 3,
    textDropDownEn: "Outpatient",
  },
];
